export enum USER_STATUS {
	Created = 0,
	Inactivated = 1,
	Activated = 2,
	Deleted = 3,
	HasToConfirmedEmail = 4,
}
